import type { ComponentProps } from "react";
import { Toolbar } from "@/components/workspace/toolbar";
export function FilterForm({ children, ...props }: ComponentProps<"form">) {
  return (
    <form {...props}>
      <Toolbar>{children}</Toolbar>
    </form>
  );
}
